define('formkit/behavior/form.condition.map.tracking.behavior',['require','exports','module','marionette'],function(require, exports, module) {
  var Mn = require('marionette');

  var FormConditionMapTrackingBehavior = Mn.Behavior.extend({
    defaults: {
      form: null
    },

    initialize: function() {
      this.listenToOnce(this.view, 'before:render', function() {
        if (this.getOption('form')) {
          this.getOption('form').enableConditionMapTracking();
        }
        else if (this.view.form) {
          this.view.form.enableConditionMapTracking();
        }
      });
    }
  })
  module.exports = FormConditionMapTrackingBehavior;
});

